<template>
	<div>
		<sBox title="Grade de navios">
			<div slot="tools">
				<div class="box-excel-export">
					<aBtn
						action="private-save-exams2"
						@click="$refs.modalExcel.open()"
						text="Importar Excel"
						icon="plus"
						size="sm"
						type="info"
						class="btn-export"
					/>
					<aBtn
						@click="handleConvertTableToXLS()"
						text="Exportar Excel"
						icon="minus"
						size="sm"
						type="info"
						class="btn-import"
					/>
				</div>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Navios">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>Empresa</span>
							<input
								v-model="filter.empresa"
								@input="
									fxFilter('empresa', $event.target.value)
								"
								type="text"
								class="form-control"
								placeholder="EMPRESA"
							/>
						</div>
						<div class="col-md-3">
							<span>Frota</span>
							<input
								v-model="filter.frota"
								@input="fxFilter('frota', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="FROTA"
							/>
						</div>

						<div class="col-sm-3">
							<span>navio</span>
							<input
								v-model="filter.navio"
								@input="fxFilter('navio', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="NAVIO"
							/>
						</div>
					</div>
				</sBox>

				<br />
				<!-- action='private-save-exams2'	 -->
				<!-- @click='this.handleConvertTableToXLS()' -->
				<div class="box-excel-export">
					<aBtn
						action="private-save-navios"
						@click="$refs.modal.open()"
						text="Navios"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-navios"
					actionDelete="private-delete-navios"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	import WBS from 'js/http';

	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroNavios',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'empresa', label: 'Empresa' },
					{ data: 'frota', label: 'Frota' },
					{ data: 'navio', label: 'Navio' },
				],
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]

				filter: {
					empresa: '',
					frota: '',
					CPF: '',
					navio: '',
				},
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.empresa != '')
					f.push(`empresa like '%${this.filter.empresa}%'`);

				if (this.filter.frota != '')
					f.push(`frota like '%${this.filter.frota}%'`);

				if (this.filter.navio != '')
					f.push(`navio like '%${this.filter.navio}%'`);

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados dos Navios.xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Navios', '']);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/navio/index.vue